module.exports = __webpack_public_path__ + "static/logo-icon-44dd82cd63f2a8409d106e839d690046.png";